import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase/config";

interface EmailTemplate {
  subject: string;
  html: string;
  text?: string;
}

interface SendEmailParams {
  to: string;
  template: EmailTemplate;
}

export const useSendEmail = () => {
  const sendEmail = async ({ to, template }: SendEmailParams) => {
    const mailRef = collection(db, "mail");

    await addDoc(mailRef, {
      to,
      message: {
        subject: template.subject,
        html: template.html,
        text: template.text,
      },
    });
  };

  return { sendEmail };
};
